//Containers

import RouteSelector from "../containers/RouteSelector";
import { views } from "./../services/constants";

const { education, investigation, cooperate, internal, root } = views;

const InternalRoutes = {
  routes: [
    /* {
      path: ["/board-curators", "/conselho-curadores"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "boardCurators"
      }
    },
    {
      path: ["/general-council", "/conselho-geral"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "generalCouncil"
      }
    },
    {
      path: ["/rector", "/reitor"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "rector"
      }
    },
    {
      path: ["/management-board", "/conselho-gestao"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "managementBoard"
      }
    },
    {
      path: ["/scientific-council", "/conselho-cientifico"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "scientificCouncil"
      }
    },
    {
      path: ["/pedagogic-council", "/conselho-pedagogico"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "pedagogicCouncil"
      }
    },
    {
      path: ["/ethics-council", "/conselho-etica-deontologia"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "ethicsCouncil"
      }
    },
    {
      path: ["/cooperation-council", "/conselho-cooperacao"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "cooperationCouncil"
      }
    },
    {
      path: ["/disciplinary-committee", "/comissao-disciplinar"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "disciplinaryCommittee"
      }
    },
    {
      path: ["/student-ombudsperson", "/provedor-estudante"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "studentOmbudsperson"
      }
    },
    {
      path: ["/statutory-auditor", "/fiscal-unico"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "statutoryAuditor"
      }
    },
    {
      path: ["/interface-units", "/unidades-interface"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "uniteInterface"
      }
    },*/
    {
      path: ["/h/:name", "/h/:name"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "people"
      }
    } /*,
    {
      path: ["/music-application-exams", "/provas-musica"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "musicApplicationExams"
      }
    },
    {
      path: ["/administration-services", "/administracao-servicos"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "administrationServices"
      }
    },
    {
      path: ["/honoris-causa", "/honoris-causa"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa"
      }
    },
    {
      path: ["/former-rectors", "/antigos-reitores"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "formerRectors"
      }
    },
    {
      path: [
        "/international-access-admission",
        "/acesso-ingresso-internacionais"
      ],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "internationalAccessAdmission"
      }
    },
    {
      path: ["/marie-curie-grant", "/bolsas-marie-curie"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "MarieCurieGrant"
      }
    },
    {
      path: ["/deliberations", "/deliberacoes"],
      component: RouteSelector,
      props: {
        activeView: internal,
        document: "deliberations"
      }
    },
    {
      path: ["/tech-offers", "/perfis-tecnologicos"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffer"
      }
    },
    {
      path: ["/tech-offer/:name", "/perfil-tecnologico/:name"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers"
      }
    },
    {
      path: ["/cooperation-area/:name", "/area-atuacao/:name"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationArea"
      }
    },
    {
      path: ["/template-exams", "/exames-modelo"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "templateExams"
      }
    },

    {
      path: ["/cooperation-area-mar", "/area-atuacao-mar"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationArea-mar"
      }
    },
    {
      path: ["/cooperation-area-floresta", "/area-atuacao-floresta"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationArea-floresta"
      }
    },
    {
      path: ["/cooperation-area-agroalimentar", "/area-atuacao-agroalimentar"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationArea-agroalimentar"
      }
    },
    {
      path: ["/cooperation-area-tice", "/area-atuacao-tice"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationArea-tice"
      }
    },
    {
      path: ["/cooperation-area-energia", "/area-atuacao-energia"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationArea-energia"
      }
    },
    {
      path: ["/cooperation-area-produtos", "/area-atuacao-produtos"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationArea-produtos"
      }
    },
    {
      path: ["/cooperation-area-artes", "/area-atuacao-artes"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationArea-artes"
      }
    },
    {
      path: ["/cooperation-area-saude", "/area-atuacao-saude"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationArea-saude"
      }
    },
    {
      path: ["/cooperation-area-territorios", "/area-atuacao-territorios"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "cooperationArea-territorios"
      }
    },
    {
      path: [
        "/former-rectors-manuel-assuncao",
        "/antigos-reitores-manuel-assuncao"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "formerRectors-manuel-assuncao"
      }
    },
    {
      path: [
        "/former-rectors-helena-nazare",
        "/antigos-reitores-helena-nazare"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "formerRectors-helena-nazare"
      }
    },
    {
      path: [
        "/former-rectors-isabel-alarcao",
        "/antigos-reitores-isabel-alarcao"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "formerRectors-isabel-alarcao"
      }
    },
    {
      path: [
        "/former-rectors-julio-pedrosa",
        "/antigos-reitores-julio-pedrosa"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "formerRectors-julio-pedrosa"
      }
    },
    {
      path: [
        "/former-rectors-renato-araujo",
        "/antigos-reitores-renato-araujo"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "formerRectors-renato-araujo"
      }
    },
    {
      path: [
        "/former-rectors-ernesto-rodrigues",
        "/antigos-reitores-ernesto-rodrigues"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "formerRectors-ernesto-rodrigues"
      }
    },
    {
      path: ["/former-rectors-victor-gil", "/antigos-reitores-victor-gil"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "formerRectors-victor-gil"
      }
    },
    {
      path: [
        "/honoris-causa-alexandre-santos",
        "/honoris-causa-alexandre-santos"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-alexandre-santos"
      }
    },
    {
      path: ["/honoris-causa-olga-roriz", "/honoris-causa-olga-roriz"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-olga-roriz"
      }
    },
    {
      path: [
        "/honoris-causa-arselio-carvalho",
        "/honoris-causa-arselio-carvalho"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-arselio-carvalho"
      }
    },
    {
      path: [
        "/honoris-causa-adriano-moreira",
        "/honoris-causa-adriano-moreira"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-adriano-moreira"
      }
    },
    {
      path: ["/honoris-causa-paul-obrien", "/honoris-causa-paul-obrien"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-paul-obrien"
      }
    },
    {
      path: [
        "/honoris-causa-manuel-oliveira",
        "/honoris-causa-manuel-oliveira"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-manuel-oliveira"
      }
    },
    {
      path: ["/honoris-causa-jose-filho", "/honoris-causa-jose-filho"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-jose-filho"
      }
    },
    {
      path: [
        "/honoris-causa-onesimo-almeida",
        "/honoris-causa-onesimo-almeida"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-onesimo-almeida"
      }
    },
    {
      path: [
        "/honoris-causa-gilles-lipovetsky",
        "/honoris-causa-gilles-lipovetsky"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-gilles-lipovetsky"
      }
    },
    {
      path: [
        "/honoris-causa-michel-waroquier",
        "/honoris-causa-michel-waroquier"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-michel-waroquier"
      }
    },
    {
      path: ["/honoris-causa-joao-coelho", "/honoris-causa-joao-coelho"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-joao-coelho"
      }
    },
    {
      path: [
        "/honoris-causa-alcino-soutinho",
        "/honoris-causa-alcino-soutinho"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-alcino-soutinho"
      }
    },
    {
      path: ["/honoris-causa-siza-vieira", "/honoris-causa-siza-vieira"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-siza-vieira"
      }
    },
    {
      path: ["/honoris-causa-souto-moura", "/honoris-causa-souto-moura"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-souto-moura"
      }
    },
    {
      path: [
        "/honoris-causa-eduardo-barroso",
        "/honoris-causa-eduardo-barroso"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-eduardo-barroso"
      }
    },
    {
      path: ["/honoris-causa-jorge-sampaio", "/honoris-causa-jorge-sampaio"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-jorge-sampaio"
      }
    },
    {
      path: ["/honoris-causa-gilberto-gil", "/honoris-causa-gilberto-gil"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-gilberto-gil"
      }
    },
    {
      path: ["/honoris-causa-joao-picoito", "/honoris-causa-joao-picoito"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-joao-picoito"
      }
    },
    {
      path: ["/honoris-causa-daciano-costa", "/honoris-causa-daciano-costa"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-daciano-costa"
      }
    },
    {
      path: ["/honoris-causa-joao-lima", "/honoris-causa-joao-lima"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-joao-lima"
      }
    },
    {
      path: [
        "/honoris-causa-antonio-damasio",
        "/honoris-causa-antonio-damasio"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-antonio-damasio"
      }
    },
    {
      path: ["/honoris-causa-eugenio-lisboa", "/honoris-causa-eugenio-lisboa"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-eugenio-lisboa"
      }
    },
    {
      path: [
        "/honoris-causa-umberto-cordani",
        "/honoris-causa-umberto-cordani"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-umberto-cordani"
      }
    },
    {
      path: ["/honoris-causa-lee-shulman", "/honoris-causa-lee-shulman"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-lee-shulman"
      }
    },
    {
      path: ["/honoris-causa-joao-lopes", "/honoris-causa-joao-lopes"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-joao-lopes"
      }
    },
    {
      path: ["/honoris-causa-harold-kroto", "/honoris-causa-harold-kroto"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-harold-kroto"
      }
    },
    {
      path: ["/honoris-causa-fernando-gil", "/honoris-causa-fernando-gil"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-fernando-gil"
      }
    },
    {
      path: [
        "/honoris-causa-sophia-andresen",
        "/honoris-causa-sophia-andresen"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-sophia-andresen"
      }
    },
    {
      path: ["/honoris-causa-nuno-portas", "/honoris-causa-nuno-portas"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-nuno-portas"
      }
    },
    {
      path: ["/honoris-causa-maria-barroso", "/honoris-causa-maria-barroso"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-maria-barroso"
      }
    },
    {
      path: ["/honoris-causa-richard-brook", "/honoris-causa-richard-brook"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-richard-brook"
      }
    },
    {
      path: ["/honoris-causa-gro-brundtland", "/honoris-causa-gro-brundtland"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-gro-brundtland"
      }
    },
    {
      path: ["/honoris-causa-fernando-graca", "/honoris-causa-fernando-graca"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-fernando-graca"
      }
    },
    {
      path: [
        "/honoris-causa-manuel-trindade",
        "/honoris-causa-manuel-trindade"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-manuel-trindade"
      }
    },
    {
      path: ["/honoris-causa-mario-corino", "/honoris-causa-mario-corino"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-mario-corino"
      }
    },
    {
      path: ["/honoris-causa-jose-simao", "/honoris-causa-jose-simao"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-jose-simao"
      }
    },
    {
      path: [
        "/honoris-causa-antonio-correia",
        "/honoris-causa-antonio-correia"
      ],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-antonio-correia"
      }
    },
    {
      path: ["/honoris-causa-manuel-lapa", "/honoris-causa-manuel-lapa"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-manuel-lapa"
      }
    },
    {
      path: ["/honoris-causa-antonio-munoz", "/honoris-causa-antonio-munoz"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-antonio-munoz"
      }
    },
    {
      path: ["/honoris-causa-ilidio-pinho", "/honoris-causa-ilidio-pinho"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "honorisCausa-ilidio-pinho"
      }
    },
    {
      path: ["/tech-offer-12017", "/perfil-tecnologico-12017"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-12017"
      }
    },
    {
      path: ["/tech-offer-12022", "/perfil-tecnologico-12022"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-12022"
      }
    },
    {
      path: ["/tech-offer-18007", "/perfil-tecnologico-18007"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-18007"
      }
    },
    {
      path: ["/tech-offer-13021", "/perfil-tecnologico-13021"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-13021"
      }
    },
    {
      path: ["/tech-offer-14011", "/perfil-tecnologico-14011"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-14011"
      }
    },
    {
      path: ["/tech-offer-14012", "/perfil-tecnologico-14012"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-14012"
      }
    },
    {
      path: ["/tech-offer-14013", "/perfil-tecnologico-14013"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-14013"
      }
    },
    {
      path: ["/tech-offer-15010", "/perfil-tecnologico-15010"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-15010"
      }
    },
    {
      path: ["/tech-offer-15013", "/perfil-tecnologico-15013"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-15013"
      }
    },
    {
      path: ["/tech-offer-15029", "/perfil-tecnologico-15029"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-15029"
      }
    },
    {
      path: ["/tech-offer-16007", "/perfil-tecnologico-16007"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-16007"
      }
    },
    {
      path: ["/tech-offer-16017", "/perfil-tecnologico-16017"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-16017"
      }
    },
    {
      path: ["/tech-offer-16018", "/perfil-tecnologico-16018"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-16018"
      }
    },
    {
      path: ["/tech-offer-16019", "/perfil-tecnologico-16019"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-16019"
      }
    },
    {
      path: ["/tech-offer-16029", "/perfil-tecnologico-16029"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-16029"
      }
    },
    {
      path: ["/tech-offer-17014", "/perfil-tecnologico-17014"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-17014"
      }
    },
    {
      path: ["/tech-offer-18001", "/perfil-tecnologico-18001"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-18001"
      }
    },
    {
      path: ["/tech-offer-18002", "/perfil-tecnologico-18002"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-18002"
      }
    },
    {
      path: ["/tech-offer-18012", "/perfil-tecnologico-18012"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-18012"
      }
    },
    {
      path: ["/tech-offer-18013", "/perfil-tecnologico-18013"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-18013"
      }
    },
    {
      path: ["/tech-offer-18014", "/perfil-tecnologico-18014"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-18014"
      }
    },
    {
      path: ["/tech-offer-18025", "/perfil-tecnologico-18025"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-18025"
      }
    },
    {
      path: ["/tech-offer-17009", "/perfil-tecnologico-17009"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-17009"
      }
    },
    {
      path: ["/tech-offer-17023", "/perfil-tecnologico-17023"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-17023"
      }
    },
    {
      path: ["/tech-offer-14031", "/perfil-tecnologico-14031"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-14031"
      }
    },
    {
      path: ["/tech-offer-17001", "/perfil-tecnologico-17001"],
      component: RouteSelector,
      props: {
        activeView: cooperate,
        document: "techOffers-17001"
      }
    }*/
  ]
};

export default InternalRoutes;
